import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomHttpParams } from '../helpers';

@Injectable({
    providedIn: 'root',
})
export class AwsApiClient {
    constructor(private http: HttpClient) {}

    put(
        url: string,
        data: any,
        contentType: string = 'application/octet-stream',
        isBackground: boolean = true
    ): Observable<any> {
        return this.http.put(url, data, {
            headers: new HttpHeaders({ 'Content-Type': contentType }),
            reportProgress: true,
            observe: 'events',
            params: new CustomHttpParams(isBackground),
        });
    }

    getS3FileBuffer(
        url: string,
        isBackground: boolean = true,
        ifModifiedSince?: string
    ): Observable<HttpResponse<ArrayBuffer>> {
        return this.http.get(url, {
            headers: ifModifiedSince ? new HttpHeaders({ 'If-Modified-Since': ifModifiedSince }) : undefined,
            responseType: 'arraybuffer',
            reportProgress: true,
            params: new CustomHttpParams(isBackground),
            observe: 'response',
        });
    }

    getS3File(url: string, isBackground: boolean = true): Observable<any> {
        return this.http.get(url, {
            responseType: 'blob',
            observe: 'events',
            params: new CustomHttpParams(isBackground),
            reportProgress: true,
        });
    }

    getS3FileRaw(url: string, isBackground: boolean = true): Observable<HttpResponse<string>> {
        return this.http.get(url, {
            responseType: 'text',
            params: new CustomHttpParams(isBackground),
            reportProgress: true,
            observe: 'response',
        });
    }
}
